import { View, Text } from 'react-native'
import Feather from '@expo/vector-icons/Feather'
import { mesaColorNames, fontFamilies } from '@/src/common/theme'

export const CardBenefitsComponentPoint = ({ text }: { text: string }) => (
  <View style={{ marginTop: 10, gap: 10 }}>
    <View style={{ flexDirection: 'row' }}>
      <Feather
        name="check"
        color={mesaColorNames['Mesa Primary Scale/400 - Brand #00DFC9']}
        style={{ marginRight: 20 }}
        size={24}
      />
      <Text
        style={{
          flexShrink: 1,
          color: mesaColorNames['Greyscale/900 #152438'],
          lineHeight: 24,
          fontSize: 14,
          fontFamily: fontFamilies['PlusJakartaSans-Regular'],
          fontWeight: 400,
        }}
      >
        {text}
      </Text>
    </View>
  </View>
)
